<div class="payment-approval-wrapper">
  <h1 mat-dialog-title class="mb-0 !text-[2.2rem] text-darkGray text-center">
    <span *ngIf="currentDialogMode === 'viewDetails'">Approve Payment</span>
    <span *ngIf="currentDialogMode === 'enterReason'">Decline Payment</span>
  </h1>
  <mat-dialog-content class="!text-sub text-darkGray">
    <ng-container *ngIf="currentDialogMode === 'viewDetails'">
      <p>Please review the proof of payment before approving.</p>
      <button
        *ngIf="canViewProofOfPayment()"
        type="button"
        class="proof-of-payment-link !mb-4"
        (click)="openProofOfPayment()"
      >
        <mat-icon>request_quote</mat-icon>
        <span>View Proof of Payment</span>
      </button>
      <p class="mat-subheading-1 !text-sub !mb-2">Payment details:</p>
      <ul class="pl-8">
        <li class="mat-subheading-1 !text-sub !mb-2">Customer&colon; {{ payment.user.profile.fullName }}</li>
        <li class="mat-subheading-1 !text-sub !mb-2">Job matter&colon; {{ payment.payable.orderable.matter }}</li>
        <li class="mat-subheading-1 !text-sub !mb-2">
          Amount&colon; {{ payment.amount | smartCurrency:payment.currency }}
        </li>
        <li class="mat-subheading-1 !text-sub !mb-2">Submission Date&colon; {{ payment.createdAt | date:'mediumDate' }}
        </li>
      </ul>
      <p>Once approved, the assigned expert will be notified to begin working on the customer's request.</p>
    </ng-container>
    <ng-container *ngIf="currentDialogMode === 'enterReason'">
      <p>Please provide a reason for declining the submitted proof of payment.</p>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput placeholder="Reason" [formControl]="reasonInput">
      </mat-form-field>
      <p>Providing a reason helps the customer understand why their proof of payment was declined.</p>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <!-- Cancel / Back button -->
    <button mat-raised-button class="bg-grey-800 text-white w-48" (click)="onCancelClicked()">
      {{ currentDialogMode === 'viewDetails' ? 'Cancel' : 'Back' }}
    </button>
    <!-- Approve button -->
    <button
      mat-raised-button
      class="w-48"
      color="primary"
      *ngIf="currentDialogMode === 'viewDetails'"
      appConfirmDialog
      confirmMessage="Are you sure you want to approve this payment?"
      (ok)="onApproveClicked()"
    >
      Approve
    </button>
    <!-- Decline / Confirm Decline button -->
    <button mat-raised-button class="w-48" color="warn" (click)="onDeclineClicked()">Decline
    </button>
  </mat-dialog-actions>
</div>
